import { Routes } from '@angular/router';
import { Layout } from './layout/layout.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  // Full-screen wizard — lives outside the Layout shell (own top bar, no sidebar/header).
  // Declared BEFORE the Layout so its `path: ''` (prefix) does not swallow this URL
  // into the automations/profiles/:id child route.
  {
    path: 'automations/profiles/create',
    loadComponent: () =>
      import(
        './components/automation-profile-wizard/automation-profile-wizard.component'
      ).then((m) => m.AutomationProfileWizard),
    canActivate: [authGuard],
  },
  {
    path: '',
    component: Layout,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/dashboard/dashboard.component').then(
            (m) => m.Dashboard,
          ),
        data: { breadcrumb: ['Dashboard'] },
      },
      {
        path: 'automations/agents',
        loadComponent: () =>
          import('./components/agents/agents.component').then(
            (m) => m.Agents,
          ),
        data: { breadcrumb: ['Automations', 'Agents'] },
      },
      {
        path: 'automations/agents/:id',
        loadComponent: () =>
          import('./components/agent-details/agent-details.component').then(
            (m) => m.AgentDetails,
          ),
        data: { breadcrumb: ['Automations', 'Agents', 'Agent Details'] },
      },
      {
        path: 'automations/profiles',
        loadComponent: () =>
          import(
            './components/automation-profiles/automation-profiles.component'
          ).then((m) => m.AutomationProfiles),
        data: { breadcrumb: ['Automations', 'Automation Profiles'] },
      },
      {
        path: 'automations/connectors',
        loadComponent: () =>
          import('./components/connectors/connectors.component').then(
            (m) => m.Connectors,
          ),
        data: { breadcrumb: ['Automations', 'Connectors'] },
      },
      {
        path: 'automations/connectors/add',
        loadComponent: () =>
          import('./components/connector-add/connector-add.component').then(
            (m) => m.ConnectorAdd,
          ),
        data: { breadcrumb: ['Automations', 'Connectors', 'Add Connector'] },
      },
      {
        path: 'automations/connectors/:type/:id',
        loadComponent: () =>
          import(
            './components/connector-details/connector-details.component'
          ).then((m) => m.ConnectorDetails),
        data: { breadcrumb: ['Automations', 'Connectors', 'Connector Details'] },
      },
      {
        path: 'automations/runs',
        loadComponent: () =>
          import('./components/automation-runs/automation-runs.component').then(
            (m) => m.AutomationRuns,
          ),
        data: { breadcrumb: ['Automations', 'Automation Runs'] },
      },
      {
        path: 'automations/runs/:commandCode',
        loadComponent: () =>
          import(
            './components/automation-run-details/automation-run-details.component'
          ).then((m) => m.AutomationRunDetails),
        data: { breadcrumb: ['Automations', 'Automation Runs', 'Run Details'] },
      },
      {
        path: 'inventory/certificates',
        loadComponent: () =>
          import('./components/certificates/certificates.component').then(
            (m) => m.Certificates,
          ),
        data: { breadcrumb: ['Inventory', 'Certificates'] },
      },
      {
        path: 'inventory/certificates/:fingerprint',
        loadComponent: () =>
          import('./components/certificate-details/certificate-details.component').then(
            (m) => m.CertificateDetails,
          ),
        data: { breadcrumb: ['Inventory', 'Certificates', 'Certificate Details'] },
      },
      {
        path: 'inventory/endpoints',
        loadComponent: () =>
          import('./components/endpoints/endpoints.component').then(
            (m) => m.Endpoints,
          ),
        data: { breadcrumb: ['Inventory', 'Endpoints'] },
      },
      {
        path: 'inventory/endpoints/:id',
        loadComponent: () =>
          import('./components/endpoint-details/endpoint-details.component').then(
            (m) => m.EndpointDetails,
          ),
        data: { breadcrumb: ['Inventory', 'Endpoints', 'Endpoint Details'] },
      },
      {
        path: 'reporting/audit-log',
        loadComponent: () =>
          import('./components/audit-log/audit-log.component').then(
            (m) => m.AuditLog,
          ),
        data: { breadcrumb: ['Reporting', 'Audit Log'] },
      },
      {
        path: 'user-management/users',
        loadComponent: () =>
          import('./components/users/users.component').then(
            (m) => m.Users,
          ),
        data: { breadcrumb: ['User Management', 'Users'] },
      },
      {
        path: 'user-management/users/:id',
        loadComponent: () =>
          import('./components/user-details/user-details.component').then(
            (m) => m.UserDetails,
          ),
        data: { breadcrumb: ['User Management', 'Users', 'User Details'] },
      },
      {
        path: 'automations/profiles/:id',
        loadComponent: () =>
          import(
            './components/automation-profile-details/automation-profile-details.component'
          ).then((m) => m.AutomationProfileDetails),
        data: { breadcrumb: ['Automations', 'Automation Profiles', 'Automation Profile Details'] },
      },
    ],
  },
  { path: '**', redirectTo: '/dashboard' },
];
